<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                if (this.field.key === 'basicInfo.nationalityId') {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationality',
                        value: selectedItem.title,
                    })
                    if (
                        selectedItem.dataSegmentId ==
                        process.env.VUE_APP_RC_ACCOUNT
                    ) {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.nationality',
                            value: selectedItem.value,
                        })
                    }
                }

                this.$store.commit('setValue', {
                    key: 'idDocumentExpiryNote',
                    value: selectedItem.idDocumentExpiryNote,
                })
            }
        },
    }, // End of Component > watch
}
</script>
